import { Backdrop, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Tooltip } from "@mui/material"
import { useEffect, useState, useMemo } from "react";
import { SelectableGroup } from "react-selectable-fast"
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useDispatch } from 'react-redux';
import { getMessSample } from "../../Store/Actions/GetMessSample";
import Swal from "sweetalert2";
import ButtonUploadImage from "./ButtonUploadImage";
import api from "../../Apis";
import ImageItem from "./ImageItem";
import AddLinkRoundedIcon from '@mui/icons-material/AddLinkRounded';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import { useForm } from "react-hook-form";
import UploadRoundedIcon from '@mui/icons-material/UploadRounded';
import UploadImageFromDevice from "./UploadImageFromDevice";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { useTranslation } from 'react-i18next';
import DialogCreateFolder from "./DialogCreateFolder";
import ManageFolderImageItem from "./ManageFolderImageItem";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { imageFolderRequest } from "../../Services/imageFolder";
import ButtonUploadVideo from "./ButtonUploadVideo";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function DialogAttachmentManager(props) {
    // console.log(props, 'props');
    const { t, i18n } = useTranslation();
    const { isOpenDialogAttachment, closeDialogAttachment, cookie, imageSelectedOld, page_name } = props;
    const [state, setState] = useState({
        image_selected: [],
        attachments: [],
        is_load_data: true,
        new_image: [],
        dialog_link: false,
        dialog_folder: false,
        dialog_folder_type: null,
        folder_edit_data: null,
        folder_selected: null
    })

    const [visibleLimit, setVisibleLimit] = useState(12);

    const dispatch = useDispatch();
    const {register, handleSubmit, reset, control, getValues, setValue} = useForm();

    const { data: folder_list, isError, isLoading: isFolderLoading } = useQuery({
        queryKey: ['imageFolder'],
        queryFn: () => 
            imageFolderRequest.getFolderList(cookie)
        ,
        retry: false,
        refetchOnWindowFocus: false,
    })
    const { data: attachments, isError: isAttachmentsErr, isLoading: isAttachmentsLoading, isFetching, isRefetching } = useQuery({
        queryKey: ["attachments"],
        queryFn: () => imageFolderRequest.getImageListFromFolder(cookie, {
            folder_id: state.folder_selected.folder_id,
            lang: i18n.language
        }),
        refetchOnWindowFocus: false,
        enabled: Boolean(state.folder_selected),
    })

    // Reset limit khi đổi folder hoặc mở lại popup
    useEffect(() => {
        setVisibleLimit(12);
    }, [state.folder_selected, isOpenDialogAttachment]);

    // Lọc danh sách ảnh
    const filteredAttachments = useMemo(() => {
        if (!attachments || !attachments.datas) return [];
        return attachments.datas.filter((item) => {
            if(props.page_name === "posts" || props.page_name === "chatbot") {
                return true;
            }
            if(props.page_name === "livechat" || props.page_name === "mess_sample_setting") {
                return item.type == "file" || item.type == "url";
            }
            return false; // Fallback
        });
    }, [attachments, props.page_name]);

    const handleLoadMore = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setVisibleLimit(prev => prev + 12);
    };

    useEffect(() => {
        setState({
            ...state,
            image_selected: imageSelectedOld
        })
    }, [imageSelectedOld])

    const onSelected = (selected) => {                
        if (selected.length) {
            const image_selected = [];
            selected.map((item) => {
                image_selected.push({
                    'mime_type': "image/jpeg",
                    'file_url': null,
                    'video_data': null,
                    'image_data': item.props.value.link,
                    'code': item.props.value.code,
                    'id': item.props.value.id,
                    'type': item.props.value.type,
                })
            })
            setState({...state, image_selected: image_selected})
        } else {
            setState({...state, image_selected: []})
        }
    }

    const onSendImage = () => {
        if (state.image_selected.length > 0) {
            const action = getMessSample({
                message: '',
                attachments: state.image_selected,
                page_name: page_name,
                rand: Math.random()
            });
            dispatch(action);
            const image_links = [];
            state.image_selected.map((item) => {
                image_links.push({
                    id: item.id,
                    code: item.code,
                    url: item.image_data
                })
            })
            props.imagePicked(image_links)
            closeDialogAttachment() 
        } else {
            Swal.fire({
                title: t("common.alert.pleaseSelectImage"),
                icon: 'warning',
                timer: 1500
            });
        }
    }

    const sendImageRightAway = (image_selected) => {
        const action = getMessSample({
            message: '',
            attachments: image_selected,
            page_name: page_name,
            rand: Math.random()
        });
        dispatch(action);
        closeDialogAttachment()
    }

    const updateAttachment = (newImages) => {
        const newlySelected = newImages.map((img) => ({
            'mime_type': img.mime_type || "image/jpeg",
            'file_url': img.file_url || null,
            'video_data': img.video_data || null,
            'image_data': img.link,
            'code': img.code,
            'id': img.id,
            'type': img.type,
        }));
    
        const updatedSelection = [...state.image_selected, ...newlySelected];
    
        const attachments = newImages.concat(state.attachments);
        
        setState({
            ...state,
            new_image: newImages,
            attachments: attachments,
            image_selected: updatedSelection 
        });
    
        queryClient.invalidateQueries(["attachments"]);
    }

    const onDeleteImage = () => {
        Swal.fire({
            title: t("common.alert.confirmDelete"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("common.alert.confirm"),
            cancelButtonText: t("common.alert.cancel")
        }).then((result) => {
            if (result.isConfirmed) {
                const image_codes = [];
                state.image_selected.map((item) => {
                    image_codes.push(item.code)
                })
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + props.cookie
                    },
                    body: JSON.stringify({
                        ids: image_codes,
                        lang: i18n.language
                    })
                };
                fetch(api.delete_multiple_image, requestOptions)
                .then(res => res.json())
                .then(
                    (result) => {
                        if (result.success) {
                            const attachmentNew = state.attachments.filter((item) => { return !image_codes.includes(item.code)})
                            setState({...state, attachments: attachmentNew, image_selected: []})
                            queryClient.invalidateQueries(["attachments"])
                        } else {
                            Swal.fire({
                                title: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK'
                            })
                        }
                    }
                )
            }
        })        
    }

    const onUploadImageByLink = (data) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + props.cookie
            },
            body: JSON.stringify({
                fanpage_id: props.fanpage_id,
                url: data.url,
                lang: i18n.language,
                folder_id: state.folder_selected.folder_id
            })
        };
        fetch(api.upload_url, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success == true) {
                    setState({...state,
                                dialog_link: false,
                                attachments: [
                                    {link: data.url, name: data.url},
                                    ...state.attachments
                                ]
                            });
                    Swal.fire({
                        title: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                    queryClient.invalidateQueries(["attachments"])
                } else {
                    Swal.fire({
                        title: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            }
        )
        reset();
    }

    const handleOpenDialogFolder = (type, folder_data) => {
        setState({...state, dialog_folder: true, dialog_folder_type: type, folder_edit_data: folder_data})
    }
    const handleCloseDialogFolder = () => {
        setState({...state, dialog_folder: false, dialog_folder_type: null, folder_edit_data: null})
    }
    const queryClient = useQueryClient();
    const mutationCreateFolder = useMutation({
        mutationFn: (data) => imageFolderRequest.createFolder(cookie, {...data, lang: i18n.language}),
        mutationKey: ["createFolder"],
        onSuccess: (data) => {
            if(data.success) {
                queryClient.invalidateQueries(["imageFolder"])
                setState((prevState) => (
                    {
                        ...prevState,
                        dialog_folder: false,
                        dialog_folder_type: null,
                        folder_edit_data: null
                    }
                ))   
            }else {
                Swal.fire({
                    title: data.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                })       
            }
            
        }
      })
      

    const onHandleCreateFolder = (data) => {
        mutationCreateFolder.mutate(data)
    }

    const editFolderMutation = useMutation({
        mutationFn: (data) => imageFolderRequest.editFolder(cookie, {...data, lang: i18n.language}),
        mutationKey: ["editFolder"],
        onSuccess: (data) => {
            if(data.success) {
                queryClient.invalidateQueries(["imageFolder"])  
            }else {
                Swal.fire({
                    title: data.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                })       
            }
            setState((prevState) => (
                {
                    ...prevState,
                    dialog_folder: false,
                    dialog_folder_type: null,
                    folder_edit_data: null
                }
            ))
        }
    })

    const onHandleEditFolder = (data) => {
        const payload = {
            folder_id: state.folder_edit_data.folder_id,
            folder_name: data.folder_name
        }
        editFolderMutation.mutate(payload)
        
    }

    const handleSelectFolder = (folder) => {
        setState({
            ...state,
            folder_selected: folder
        })
    }


    const mutationDeleteFolder = useMutation({
        mutationFn: (folder_id) => imageFolderRequest.deleteFolder(cookie, {folder_id, lang: i18n.language}),
        mutationKey: ["deleteFolder"],
        onSuccess: (data) => {
            if(data.success) {
                queryClient.invalidateQueries(["imageFolder"])
            }else {
                Swal.fire({
                    title: data.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                })       
            }
            setState((prevState) => (
                {
                    ...prevState,
                    dialog_folder: false,
                    dialog_folder_type: null,
                    folder_edit_data: null
                }
            ))
        }
      })
    const handleDeleteFolder = (folder) => {
        Swal.fire({
            title: t("common.alert.confirmDelete"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("common.alert.confirm"),
            cancelButtonText: t("common.alert.cancel")
        }).then((result) => {
            if (result.isConfirmed) {
                mutationDeleteFolder.mutate(folder.folder_id)    
            }
        })

    }

    const showUseAnDeleteLabel = (type) => {
        const imageCount = state.image_selected.filter(item => item.type === "file" || item.type === "url").length;
        const videoCount = state.image_selected.filter(item => item.type === "video").length;
        
        const stringType = type === "use" ? t("common.use") : t("common.delete");
        
        if(imageCount > 0 && videoCount > 0) {
            return `${stringType} ${t("common.upload.mediaSummary", {imageCount, videoCount})}`;
        }
        if(imageCount > 0) {
            return `${stringType} ${t("common.upload.imageCount", {
                count: imageCount
            })}`;
        }
        if(videoCount > 0) {
            return `${stringType} ${t("common.upload.videoCount", {
                count: videoCount
            })}`;
        }
    }
   
    if (!isOpenDialogAttachment) return null;
    return (
        <>
  
            <Dialog open={state.dialog_link} fullWidth={true} maxWidth='sm' onClose={() => {setState({...state, dialog_link: false})}}>
            
                <DialogTitle>{t("common.upload.enterImageLink")}</DialogTitle>
                <form onSubmit={handleSubmit(onUploadImageByLink)}>
                    <DialogContent sx={{paddingTop: '0px'}}>
                        <p className='m-b-0 m-t-0'>
                           {t("common.upload.uploadImageToFanpage")}
                        </p>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label={t("common.upload.yourImageUrl")}
                            type="text"
                            fullWidth
                            variant="outlined"
                            {...register('url')}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {setState({...state, dialog_link: false})}}>{t("common.close")}</Button>
                        <Button type="submit">{t("common.confirm")}</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                fullWidth={true}
                maxWidth='lg'
                open={isOpenDialogAttachment}
                onClose={closeDialogAttachment}
                BackdropProps={{
                    sx: {
                        // Thay đổi màu sắc và độ mờ tại đây
                        backgroundColor: 'rgba(0, 0, 0, 0.7)', 
                        // Nếu muốn hiệu ứng mờ kính (glassmorphism)
                        backdropFilter: 'blur(10px)',
                    }
                }}
            >
                <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={mutationDeleteFolder.isLoading || editFolderMutation.isLoading || mutationCreateFolder.isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
                <DialogTitle sx={{display: "flex", justifyContent: "space-between"}}>
                   {t("common.upload.shopImages")}
                    <Button startIcon={<CloseOutlinedIcon />} variant="contained" color="warning" onClick={closeDialogAttachment}>
                        {t("common.close")}
                    </Button>
                </DialogTitle>
                <DialogContent sx={{overflowY: "unset", paddingBottom: "0px"}}>
                    {
                        state.folder_selected && (
                            <>
                                <Button
                                sx={{
                                    marginRight: '20px'
                                }}
                                onClick={() => setState({...state, folder_selected: null, image_selected: []})}
                                variant="contained"
                                color="primary"
                                startIcon={<ArrowBackIcon />}
                            >
                                {t("common.back")}    
                            </Button>        
                            <ButtonUploadImage
                                cookie={props.cookie}
                                fanpage_id={props.fanpage_id}
                                updateAttachment={updateAttachment}
                                folder_selected={state.folder_selected}
                            />
                            {
                                props.page_name === "posts" &&
                                <ButtonUploadVideo 
                                    fanpage_id={props.fanpage_id}
                                    cookie={props.cookie}
                                    updateAttachment={updateAttachment}
                                    folder_selected={state.folder_selected}
                                />
                            }
                            <Button sx={{
                                marginRight: '20px'
                                }} onClick={() => {setState({...state, input_link: true, dialog_link: true})}} variant="outlined" color="success" startIcon={<AddLinkRoundedIcon />}>
                            {t("common.upload.uploadFromUrl")}
                            </Button>
                            {
                            page_name == "livechat" &&
                                <UploadImageFromDevice
                                fanpage_id={props.fanpage_id}
                                cookie={props.cookie}
                                sendImageRightAway={sendImageRightAway}
                                folder_selected={state.folder_selected}
                                />
                            }                          
                        </>
                        )
                    }
                    {
                        !state.folder_selected && (
                            <Button
                                sx={{
                                marginRight: "20px",
                                }}
                                onClick={() => handleOpenDialogFolder("create")}                             
                                variant="outlined"
                                color="primary"
                                startIcon={<CreateNewFolderIcon />}
                            >
                                {t("common.upload.createFolder")}
                            </Button>
                            )
                        }
                        <DialogCreateFolder dialog_folder={state.dialog_folder} dialog_folder_type={state.dialog_folder_type} handleCloseDialogFolder={handleCloseDialogFolder} onHandleCreateFolder={onHandleCreateFolder} onHandleEditFolder={onHandleEditFolder} folder_edit_data={state.folder_edit_data}  />
                    {/* <TextField sx={{
                        marginRight: '20px'
                        }} size="small" id="outlined-basic" onChange={handleChangeKeySearch} label="Tìm kiếm tên ảnh" variant="outlined"></TextField> */}
                    {
                        state.image_selected.length > 0 &&
                        <Button sx={{
                            marginRight: '20px'
                            }} onClick={onSendImage} variant="outlined" color="warning">{
                                // t("setting.useImages", {count:  state.image_selected.length})
                                showUseAnDeleteLabel("use")
                            }</Button>
                    }
                    {
                        state.image_selected.length > 0 &&
                        <Button onClick={onDeleteImage} variant="outlined" color="error">{
                            // t("setting.deleteImages", {count:  state.image_selected.length})
                            showUseAnDeleteLabel("delete")
                            }</Button>
                    }
                    
                </DialogContent>
                <DialogContent>
                    {
                        state.folder_selected && (
                            <>        
                                <p style={{margin: "-15px 0px 10px 0px", fontSize: "18px"}}>
                                    <small>{t("setting.selectImagesInstructions")}</small>
                                </p>
                                {isAttachmentsLoading || isFetching || isRefetching ? ( 
                                <p style={{textAlign: "center", width: "100%"}}>
                                    <CircularProgress />
                                </p>)
                                : 
                                (<SelectableGroup
                                    allowClickWithoutSelected={true}
                                    tolerance={0}
                                    // duringSelection={handleDuringSelection}
                                    onSelectionFinish={(selected) => onSelected(selected)}
                                    ignoreList={['.name-col', '.h-col', '.s-col', '.u-col', '.v-col', '.btn-load-more']} // Thêm .btn-load-more vào ignoreList
                                    // scrollContainer={window}
                                    // scrollContainer={".MuiDialog-container"}
                                >
                                    <Box sx={{ flexGrow: 1 }}>
                                        <Grid container spacing={2}>
                                            {
                                                (!isAttachmentsLoading && !isFetching) && filteredAttachments.slice(0, visibleLimit).map((value, key) => {
                                                const isCurrentSelected = state.image_selected.some(
                                                    (item) => String(item.code) === String(value.code) || String(item.id) === String(value.id)
                                                );
                                                    return (
                                                        <ImageItem
                                                            value={value}
                                                            key={value.code}
                                                            index={key}
                                                            isSelected={isCurrentSelected} 
                                                        />
                                                    )
                                                })
                                            }
                                        </Grid>
                                        
                                        {(!isAttachmentsLoading && !isFetching) && filteredAttachments.length > visibleLimit && (
                                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, mb: 2 }}>
                                                <Button 
                                                    variant="outlined" 
                                                    className="btn-load-more"
                                                    onClick={handleLoadMore}
                                                    sx={{ borderRadius: '20px', px: 4, mt: 2 }}
                                                    startIcon={<ExpandMoreIcon />}
                                                >
                                                    {t("common.loadMore") || "Tải thêm"} ({filteredAttachments.length - visibleLimit})
                                                </Button>
                                            </Box>
                                        )}
                                    </Box>
                                </SelectableGroup>
                                                )}
                                
                            </>
                        )
                    }
                    {
                    isFolderLoading && !state.folder_selected && (
                            <p style={{textAlign: "center", width: "100%"}}>
                                <CircularProgress />
                            </p>
                        )}
                    {   
                        
                        !state.folder_selected && (
                            <Box sx={{ flexGrow: 1 }}>
                                <Grid container spacing={2}>
                                    {
                                       folder_list && folder_list.datas?.map((folder, index) =>
                                           <ManageFolderImageItem key={index} folder={folder} handleSelectFolder={handleSelectFolder} handleOpenDialogFolder={handleOpenDialogFolder} handleDeleteFolder={handleDeleteFolder}  />
                                        )
                                    }
                                </Grid>
                            </Box>
                        )
                    }
                </DialogContent>
            </Dialog>
        </>
        
    )
}